import { Divider, Grid, Stack } from '@mui/material'
import { Box } from '@mui/system'
import MUIDataTable from 'mui-datatables'
import React, { useState } from 'react'
import { ContainedButton } from '../../components/600/MyButtons'
import { useEffect } from 'react'
import { MyDropdown } from '../../components/600/MyDropdown'
//import api from '../api/mainAPI'// proxy might have been provided
//import BatchReportContext from './contexts/ContextProvider'
import StaffReportContext  from '../../context/600/StaffReportContextProvider'
import { useContext } from 'react'
import { MyTab } from '../../components/600/MyTabs'
import { MyBarChartCard, MyPieChartCard, MyTextCard } from '../../components/600/MyCards'
//import { LoadCoverage } from './loadCoverage'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import Staffs from '../200/Staffs'


const options = {
  filterType: 'checkbox',
};

const StaffReport = () => {

  
  // const [reportState, reportDispatch] = useContext(BatchReportContext)
  const [reportState, reportDispatch] = useContext(StaffReportContext)
  const [visualize, setVisualize] = useState(false);
  const api = useAxiosPrivate()
  useEffect(() => {
    api.get('/reports/staff')
    .then(res => {
      // console.log(res.data)
      reportDispatch({type: 'loadStaff', payload: {
        staffCount: res.data.staffCount,
        groups: res.data.groupCount, 
        semesters: res.data.semesters, 
        selectedSemester: res.data.currentTerm.semester_term,
        selectedTerm: res.data.currentTerm.academic_year, 
        tableData: res.data.tableData,
        tableHeader: res.data.tableHeader,
        partimer: res.data.partimer,
        fulltimer : res.data.fulltimer,

      }}) 
  })}, [])

  // useEffect(() => {

  //   api.get("batchReport/filter",{
  //     params:{
  //       semester: reportState.selectedSemester,
  //       term: reportState.selectedTerm,
  //       department: 1,
  //       tab: reportState.tab,
  //     }
  //   })
  //   .then(res => console.log(res.data))
  //   .catch(err => console.log('Error:', err))
  // }, [reportState.selectedTerm, reportState.selectedSemester, reportState.tab])
  var terms = reportState.semesters.filter(semester => semester.semester_term === 1).map(filteredSemester => (filteredSemester.academic_year))
  console.log("table Column : "+reportState.tableColumn)

//=======
  //   if(reportState.selectedTerm === '') {
  //     api.get('batchReport')
  //     .then(res => {
  //       console.log(res.data)
  //       reportDispatch({type: 'load', payload: res.data})
  //     })
  //     .catch(err => console.log('Error:', err))
  //   } else {
  //       api.get("batchReport/filter",{
  //         params:{
  //           semester: reportState.selectedSemester,
  //           term: reportState.selectedTerm,
  //           department: 1,
  //         }
  //       })
  //       .then(res => {
  //         console.log(res.data)
  //         console.log(res.data.batches)
  //         reportDispatch({type: 'load', payload: res.data})
  //       })
  //       .catch(err => console.log('Error:', err))
  //   }
  // }, [reportState.selectedSemester, reportState.selectedTerm])
  const handleCollegeFilter = (e) => {
    reportDispatch({
      type: "load",
      payload: { selectedCollege: e.target.value },
    });
  };
  const handleDepartmentFilter = (e) => {
    reportDispatch({
      type: "load",
      payload: { selectedDepartment: e.target.value },
    });
  };
  const handleSemesterFilter = (e) => {
    reportDispatch({
      type: "changeSemester",
      payload: { selectedSemester: e.target.value },
    });
  };
  const handleTermFilter = (e) => {
    reportDispatch({ type: 'changeTerm', payload: {selectedTerm: e.target.value}})
  }
  function handleTabChange(value) {
    reportDispatch({ type: 'changeTab', payload: {selectedTab: value}})
  }
  function handleVisualization() {
    setVisualize(!visualize);
  }

  return (

    <Box sx={{ m: 2 }}>
      {/* Filters */}
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "right", sm: "center" }}
        justifyContent="flex-end"
        spacing={2}
        divider={<Divider orientation="vertical" flexItem />}
        sx={{
          m: 1,
          md: {
            backgroundColor: "#ff0",
          },
        }}>
        {/* Semester filter */}
        <MyDropdown
          inputs={{
            name: "College",
            defaultValue: reportState.selectedCollege,
            handleChange: handleCollegeFilter,
            id: "Semester_filter",
            values: [
              "All",
              "Electrical and Mechanical Engineering",
              "Civil and Architectural Engineering",
              "Applied Sciences",
            ],
            disable: false,
          }}
        />
        <MyDropdown
          inputs={{
            name: "Department",
            defaultValue: reportState.selectedDepartment,
            handleChange: handleDepartmentFilter,
            id: "Semester_filter",
            values: [
              "All",
              "Software Engineering",
              "Electrical Engineering",
              "Mechanical Engineering",
            ],
            disable: false,
          }}
        />
        <MyDropdown
          inputs={{
            name: "Semester",

            defaultValue: reportState.selectedSemester,
            handleChange: handleSemesterFilter,
            id: "Semester_filter",
            values: [1, 2],
          }} />

        {/* Term Filter */}
        <MyDropdown
          inputs={{
            name: "Term",
            defaultValue: `${reportState.selectedTerm}`,
            handleChange: handleTermFilter,
            id: 'Term_filter', 
            values: terms,
          }} />
        {/* Charts Toggle Button */}
        <ContainedButton
          variant="contained"
          color="secondary"
          onClick={handleVisualization}>
          {visualize ? "Visualize" : "Report"}
        </ContainedButton>
      </Stack>
      {/* Visualize */}
      <Grid container 
          spacing={{ xs: 2, md: 3 }} 
          columns={{ xs: 4, sm: 8, md: 12 }} 
          sx={{m: 1, mb: 2}}
      >
          <MyTextCard inputs={{
            value: reportState.staffCount,
            title: 'Total Staff',
            size: 5,
          }}/>
          {/* <MyTextCard inputs={{
            value: reportState.groups,
            title: 'Groups Formulated',
            size: 3,
          }}/> */}
          {visualize && 
          <MyBarChartCard inputs={{    ////Maybe here {potentially}
            title: "Division",
            option1: 'Part-timer',
            value1: reportState.partimer,
            option2: 'Full-timer',
            value2: reportState.fulltimer
          }}/>}
          {visualize && 
          <MyBarChartCard inputs={{
              title: 'Admission',
              option1: 'UnderLoad',
              value1: 4,
              option2: 'OverLoad',
              value2: 1
            }} 
          />}
          {!visualize && 
          <MyPieChartCard inputs={{
              mydata: {
                name: "Program",
                option1: "Regular",
                option2: "Extension",
                value1: reportState.partimer,
                value2: reportState.fulltimer,
              },
            }}
          />}
          {!visualize && 
          <MyPieChartCard inputs={{
            mydata: {
              name: "Admission",
              option1: "Underload",
              option2: "Overload",
              value1: 4,
              value2:1,
            },
          }}/>
          }
      </Grid>
      {/* Load Coverage */}
      {/* <LoadCoverage  inputs={{
        load: reportState.load
      }}/> */}
      {/* Tabs */}
    {/* <Box sx={{ width: '100%' }}>
      <Box>
        <MyTab inputs={{
          tabs: [
            {label: 'Batches', tab: 0},
            {label: 'Sections', tab: 1},
            {label: 'Groups', tab: 2},
          ],
          defaultTab: reportState.tab,
          handleTabChange,
        }}/>
      </Box>
    </Box> */}
    {/* <MUIDataTable 
        title={reportState.tableHeader}
        data={reportState.tableData} 
        columns={reportState.tableColumn}
        options={options}
    /> */}
  <Staffs display='yes'/>

    </Box>
  );
};

export default StaffReport;
